import { Link, Redirect } from "@reach/router";
import { JourneyProps } from "./Interfaces";
import Journey from "./Journey";
import JourneyRoute from "./JourneyRoute";
import templatesLibrary from "./TemplatesLibrary";

const processJourney = function (props: JourneyProps, journeyStore: any) {


    let links: JSX.Element[] = [];
    let routes: JSX.Element[] = [];
    let hasMatch: boolean = false;

    const getTemplate = function (newPath: string, pageName: Object, page: any, passedProps: any, index: any) {
        let tLink = <Link to={newPath} key={"linkT-" + newPath}><span className="p-4">{pageName}</span></Link>
        let tRoute = <JourneyRoute key={"routeT-" + newPath} Route={templatesLibrary[page.template]} path={newPath} passedProps={passedProps} index={index} />
        return { tLink, tRoute }
    }
    const getJourney = function (newPath: string, pageName: Object, JourneyObj: any, passedProps: any, index: any) {
        let jLink = <Link to={newPath} key={"linkJ-" + newPath}><span className="p-4">{pageName}</span></Link>
        let jRoute = <JourneyRoute key={"routeJ-" + newPath} Route={JourneyObj} path={newPath + "/*"} passedProps={passedProps} index={index} />
        return { jLink, jRoute }
    }

    //Processes a journey file's pages to build routes for the router.
    Object.entries(props.pages).forEach(
        ([pageName, page], index) => {
            let newPath = (page.hasOwnProperty("path") ? page.path : pageName) || "/";
            if (page.hasOwnProperty('nextScreen')) {
                console.log(pageName)
            }
            if (newPath === "/" || newPath === "/*") hasMatch = true;
            //This section processes conditional logic. Instead of passing a template or journey prop, you pass an options array containting template or journey definitions and a condition string that evaluates as an expression.
            let matchedOption = page;
            let passedProps = {};
            if (matchedOption.hasOwnProperty('options')) {
                //Run through all of the options.
                //@ts-ignore
                var i = 0, len = page.options.length || 0;
                while (i < len) {
                    //Check to see if the condition string evaluates as true as an expression.
                    let evaluation;
                    //@ts-ignore
                    if (page.options[i].hasOwnProperty("condition")) {
                        //@ts-ignore
                        evaluation = evalSafely(page.options[i].condition, journeyStore);
                    }
                    //@ts-ignore
                    if ((typeof evaluation === "boolean" && evaluation) || i === len) {
                        //@ts-ignore
                        matchedOption = page.options[i];
                        i += len;
                    }
                    i++
                }
            }
            if (matchedOption.hasOwnProperty('redirect')) {
                //@ts-ignore
                routes.push(<Redirect key={index} noThrow to={"../" + matchedOption.redirect} from={page.path} />)
            }
            if (matchedOption.hasOwnProperty('template')) {
                //@ts-ignore
                passedProps = (matchedOption.templateProps ? { templateProps: matchedOption.templateProps, parentDestination: props.journeyProps ? props.journeyProps.nextScreen || "" : "" } : {})
                let { tLink, tRoute } = getTemplate(newPath, pageName, matchedOption, passedProps, index)
                links.push(tLink)
                routes.push(tRoute)
            }
            if (matchedOption.hasOwnProperty('journey')) {
                //@ts-ignore
                passedProps = { goal: journeysLibrary[matchedOption.journey].goal, pages: journeysLibrary[matchedOption.journey].pages, journeyProps: matchedOption.journeyProps }
                let { jLink, jRoute } = getJourney(newPath, pageName, Journey, passedProps, index)
                links.push(jLink)
                routes.push(jRoute)
            }
        }
    )
    //If there's no match for /, redirect to the first path in the object.
    if (!hasMatch) {
        //firstPath is either first object's path definition, with a fallback to object's key name.
        let firstPath = (props.pages[Object.keys(props.pages)[0]].path || Object.keys(props.pages)[0]);
        routes.push(<Redirect noThrow key={firstPath} to={firstPath} from="/" />)
        //routes.push(<Redirect noThrow to={firstPath} from="/*" />)
    }
    //console.log(links, routes)
    return { links, routes }
}

export default processJourney;